import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  MenuItem,
  TextField,
  Button,
  Box,
  Typography,
  Tooltip,
} from "@mui/material";
import UploadFile from "@mui/icons-material/UploadFile";
import { darken } from "@mui/system";
import InputText from "../../Fields/InputText";

const formColor = { hcs: "#dd5200", arjo: "#0F5376" };

export default class CompanyType extends React.Component {
  static propTypes = {
    customerInformation: PropTypes.object,
    extraFiles: PropTypes.array,
    labels: PropTypes.object,
    handleChange: PropTypes.func,
    changeHandler: PropTypes.func,
    formInformation: PropTypes.object,
    color: PropTypes.string,
    formType: PropTypes.string,
    lang: PropTypes.string,
  };

  state = {
    companyType: "",
    fileRequired: false,
  };

  handleCompanyTypeChange = (event) => {
    const companyType = event.target.value;
    const required =
      companyType === this.props.labels.golf_club ||
      companyType === this.props.labels.sports_club ||
      companyType === this.props.labels.housing_association;

    const labelToKey = {
      [this.props.labels.municipality]: "municipality",
      [this.props.labels.church]: "church",
      [this.props.labels.golf_club]: "golf_club",
      [this.props.labels.sports_club]: "sports_club",
      [this.props.labels.housing_association]: "housing_association",
      [this.props.labels.other2]: "other2",
    };
    const labelToKeyJP = {
      [this.props.labels.municipality]: "Municipality",
      [this.props.labels.church]: "Church/Community",
      [this.props.labels.golf_club]: "Golf club",
      [this.props.labels.sports_club]: "Sports club",
      [this.props.labels.housing_association]: "Housing association",
      [this.props.labels.other2]: "Other",
    };
    const companyTypeKey = labelToKey[companyType] || "";
    const companyTypeEn =
      this.props.lang.toLowerCase() === "jp"
        ? labelToKeyJP[companyType] || ""
        : "";

    this.setState({ companyType, fileRequired: required });
    this.props.changeHandler({
      companyType: companyType,
      companyTypeKey: companyTypeKey,
      companyTypeEn: companyTypeEn,
      companyTypeFinished: true,
      requiresExtraFile: required,
    });
  };

  handleCustomerNameChange = (value, id) => {
    let data = {};
    data[id] = value;
    this.props.changeHandler(data);
  };

  handleAddfile = (event) => {
    let files = [];
    const allowedTypes = ["image/jpeg", "application/pdf", "image/png"];
    const maxFileSize = 5 * 1024 * 1024;
    for (let i = 0; i < event.target.files.length; i++) {
      if (!allowedTypes.includes(event.target.files[i].type)) {
        alert(this.props.labels.wrong_filetype);
        continue;
      }
      if (event.target.files[i].size > maxFileSize) {
        alert(this.props.labels.large_file);
        continue;
      }
      if (files.length + this.props.extraFiles.length > 4) {
        alert(this.props.labels.too_many_files);
        continue;
      }
      if (
        !this.props.extraFiles.some(
          (file) => file.name === event.target.files[i].name,
        )
      ) {
        let element = event.target.files[i];
        files.push(element);
      } else {
        alert(this.props.labels.duplicate_filename);
      }
    }
    this.props.changeHandler({ businessExtraFiles: files });
    event.target.value = null;
  };

  render() {
    const { labels, extraFiles } = this.props;
    const company_type_options = [
      {
        value: this.props.labels.municipality,
        label: this.props.labels.municipality,
      },
      { value: this.props.labels.church, label: this.props.labels.church },
      {
        value: this.props.labels.golf_club,
        label: this.props.labels.golf_club,
      },
      {
        value: this.props.labels.sports_club,
        label: this.props.labels.sports_club,
      },
      {
        value: this.props.labels.housing_association,
        label: this.props.labels.housing_association,
      },
      { value: this.props.labels.other2, label: this.props.labels.other2 },
    ];

    const formType = this.props.formType.toLowerCase();
    const showCompanyField = formType === "upcare" || formType === "flexpro";

    return (
      <Grid container spacing={2}>
        <Grid item xs={showCompanyField ? 6 : 12}>
          <Tooltip
            title={
              <span style={{ fontSize: "12px" }}>
                {this.props.labels.tooltip_companytype}
              </span>
            }
            placement="top"
          >
            <TextField
              select
              label={this.props.labels.companytype}
              value={this.props.customerInformation.companyType}
              onChange={this.handleCompanyTypeChange}
              fullWidth
              required={true}
              className={
                this.props.formInformation.showInvalid &&
                !this.props.customerInformation.companyType
                  ? "invalid"
                  : ""
              }
            >
              {company_type_options.map((option) => (
                <MenuItem value={option.value} key={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Tooltip>
        </Grid>
        {showCompanyField && (
          <Grid item xs={6}>
            <InputText
              id="customerName"
              label={this.props.labels.company}
              changeHandler={this.handleCustomerNameChange}
              defaultValue={this.props.customerInformation.customerName}
              tooltip={this.props.labels.tooltip_company_name}
              required={true}
              sx={{ width: "100%" }}
              className={
                this.props.formInformation.showInvalid &&
                !this.props.customerInformation.customerName
                  ? "invalid"
                  : ""
              }
            />
          </Grid>
        )}
        {/* Not needed at the moment, but it may be in the future */}

        {/* {this.props.customerInformation.requiresExtraFile && (
          <Grid item xs={12}>
            <Box textAlign="left">
              {this.props.extraFiles.length === 0 && (
                <Typography
                  variant="caption"
                  display="block"
                  gutterBottom
                  style={{ fontSize: "1.3rem", color: "red" }}
                >
                  <strong>{this.props.labels.companytype_more_info}</strong>
                </Typography>
              )}
              <Button
                variant="contained"
                component="label"
                sx={{
                  backgroundColor: this.props.color,
                  "&:hover": {
                    backgroundColor: darken(this.props.color, 0.2), // Darken by 20%
                  },
                  marginBottom: 0.5,
                }}
                startIcon={<UploadFile />}
              >
                {this.props.labels.upload_extra_files}
                <input
                  type="file"
                  accept="image/jpeg, application/pdf, image/png"
                  multiple
                  hidden
                  onChange={this.handleAddfile}
                />
              </Button>
            </Box>

            <div id="fileContents">
              {extraFiles.length > 0 && <p>{labels.uploaded_files}</p>}
              {extraFiles.map((file) => (
                <Button
                  variant="text"
                  className="file"
                  key={file.name}
                  onClick={() => {
                    let index = extraFiles.indexOf(file);
                    if (index !== -1) {
                      extraFiles.splice(index, 1);
                    }
                    this.props.changeHandler({
                      businessExtraFiles: extraFiles,
                    });
                  }}
                >
                  {file.name}
                </Button>
              ))}
            </div>
          </Grid>
        )} */}
      </Grid>
    );
  }
}
